import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { t } from '@nextcloud/l10n'
import IconInformationOutline from 'vue-material-design-icons/InformationOutline.vue'
import EmptyView from '../components/EmptyView.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'SessionConflictView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmptyView, {
    name: _unref(t)('spreed', 'Duplicate session'),
    description: _unref(t)('spreed', 'You joined the conversation in another window or device. This is currently not supported by Nextcloud Talk so this session was closed.')
  }, {
    icon: _withCtx(() => [
      _createVNode(IconInformationOutline)
    ]),
    _: 1
  }, 8, ["name", "description"]))
}
}

})